import { render, staticRenderFns } from "./ExploreTrainings.vue?vue&type=template&id=18e7ec8c&scoped=true"
import script from "./ExploreTrainings.vue?vue&type=script&lang=js"
export * from "./ExploreTrainings.vue?vue&type=script&lang=js"
import style0 from "./ExploreTrainings.vue?vue&type=style&index=0&id=18e7ec8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e7ec8c",
  null
  
)

export default component.exports